"use strict";
'use client';

/**
 * Generated by `./scripts/prebuild/generate-icons.ts`.
 * Run `yarn generate-icons` to regenerate.
 */
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Experimental__IconPlayNext = Experimental__IconPlayNext;
exports.IconPlayNext = IconPlayNext;
var _react = _interopRequireDefault(require("react"));
var _index = require("../../index.js");
/**
 * @deprecated IconPlayNext is deprecated and will be archived soon. To find a suitable alternative, refer to https://encore.spotify.net/foundation/basics/icons?format=web-js#browse-icons.
 */
function IconPlayNext(props) {
  /* prettier-ignore */
  var iconList = [{
    'size': 16,
    'svgContent': '<path d=\'M15.5 2H14V.5a.481.481 0 00-.147-.353A.481.481 0 0013.5 0a.481.481 0 00-.353.147A.481.481 0 0013 .5V2h-1.5a.481.481 0 00-.353.147A.481.481 0 0011 2.5c0 .137.049.255.147.353A.481.481 0 0011.5 3H13v1.5c0 .137.049.255.147.353A.481.481 0 0013.5 5a.481.481 0 00.353-.147A.481.481 0 0014 4.5V3h1.5a.481.481 0 00.353-.147A.481.481 0 0016 2.5a.481.481 0 00-.147-.353A.481.481 0 0015.5 2zM4 2.817V13.19c0 .323.106.534.317.631.212.098.466.057.762-.123l8.207-5.031c.296-.18.444-.4.444-.66 0-.259-.148-.478-.444-.658L5.079 2.31c-.296-.18-.55-.22-.762-.122-.211.097-.317.306-.317.629z\'/>'
  }, {
    'size': 24,
    'svgContent': '<path d=\'M23.25 3H21V.75a.722.722 0 00-.22-.53.722.722 0 00-.53-.22.722.722 0 00-.53.22.722.722 0 00-.22.53V3h-2.25a.722.722 0 00-.53.22.722.722 0 00-.22.53c0 .206.073.383.22.53.148.146.324.22.53.22h2.25v2.25c0 .206.073.383.22.53.148.146.324.22.53.22a.722.722 0 00.53-.22.722.722 0 00.22-.53V4.5h2.25a.722.722 0 00.53-.22.722.722 0 00.22-.53.722.722 0 00-.22-.53.722.722 0 00-.53-.22zM6 4.226v15.559c0 .485.159.8.476.947.317.146.699.085 1.143-.185l12.31-7.546c.444-.27.666-.6.666-.99 0-.388-.222-.717-.666-.987L7.619 3.465c-.444-.27-.825-.331-1.143-.183-.317.145-.476.46-.476.944z\'/>'
  }];
  var closestSize = (0, _index.findClosestGlyphAvailable)(iconList, props.iconSize || 24);
  var titleTag = function titleTag(title, titleId) {
    return title ? "<title ".concat(titleId ? "id=\"".concat(titleId, "\"") : "", ">").concat(title, "</title>") : "";
  };
  var descTag = function descTag(desc, descId) {
    return desc ? "<desc ".concat(descId ? "id=\"".concat(descId, "\"") : "", ">").concat(desc, "</desc>") : "";
  };
  var autoMirror = props.autoMirror || false;
  return /*#__PURE__*/_react["default"].createElement(_index.Icon, Object.assign({}, props, {
    autoMirror: autoMirror,
    viewBox: "0 0 ".concat(closestSize.size, " ").concat(closestSize.size),
    dangerouslySetInnerHTML: {
      __html: "".concat(titleTag(props.title, props.titleId)).concat(descTag(props.desc, props.descId)).concat(closestSize.svgContent)
    }
  }));
}

/**
 * @deprecated IconPlayNext is deprecated and will be archived soon. To find a suitable alternative, refer to https://encore.spotify.net/foundation/basics/icons?format=web-js#browse-icons.
 */
function Experimental__IconPlayNext(props) {
  return /*#__PURE__*/_react["default"].createElement(IconPlayNext, props);
}